<template>
    <div class="navbar-area" v-if="preferencias">
        <div class="main-responsive-nav">
            <div class="container">
                <div class="main-responsive-menu">
                    <div class="logo">
                        <a href="/" v-if="preferencias.valor">
                            <img
                                style="max-width: 150px !important"
                                :src="preferencias.valor.logo"
                                alt="image"
                            />
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="main-navbar">
            <div class="container-fluid">
                <nav class="navbar navbar-expand-md navbar-light">
                    <a class="navbar-brand" href="/" v-if="preferencias.valor">
                        <img :src="preferencias.valor.logo" alt="image" />
                    </a>
                    <div
                        class="collapse navbar-collapse mean-menu"
                        id="navbarSupportedContent"
                        style="display: block"
                    >
                        <ul class="navbar-nav" v-if="menu">
                            <li
                                class="nav-item"
                                v-for="(item, index) in menu.opciones"
                                :key="index"
                            >
                                <router-link
                                    v-if="item.tipo != 3"
                                    :to="{
                                        name: 'page',
                                        params: { id: item.url },
                                    }"
                                    class="nav-link"
                                >
                                    {{ item.nombre }}
                                    <i
                                        class="bx bx-chevron-down"
                                        v-if="item.opciones.length > 0"
                                    ></i>
                                </router-link>
                                <a
                                    v-if="item.link != '#' && item.tipo == 3"
                                    target="_blank"
                                    :href="item.link"
                                    class="nav-link"
                                >
                                    {{ item.nombre }}
                                    <i
                                        class="bx bx-chevron-down"
                                        v-if="item.opciones.length > 0"
                                    ></i>
                                </a>

                                <a
                                    v-if="item.link == '#' && item.tipo == 3"
                                    :href="'javascript:void(0)'"
                                    class="nav-link"
                                >
                                    {{ item.nombre }}
                                    <i
                                        class="bx bx-chevron-down"
                                        v-if="item.opciones.length > 0"
                                    ></i>
                                </a>

                                <ul
                                    v-if="item.opciones.length > 0"
                                    class="dropdown-menu"
                                >
                                    <li
                                        class="nav-item"
                                        v-for="(
                                            option, indice
                                        ) in item.opciones"
                                        :key="indice"
                                    >
                                        <router-link
                                            v-if="option.tipo != 3"
                                            :to="{
                                                name: 'page',
                                                params: { id: option.url },
                                            }"
                                            class="nav-link"
                                        >
                                            {{ option.nombre }}
                                        </router-link>
                                        <a
                                            v-else
                                            target="_blank"
                                            :href="option.link"
                                            class="nav-link"
                                        >
                                            {{ option.nombre }}
                                            <i
                                                class="bx bx-chevron-down"
                                                v-if="
                                                    option.opciones.length > 0
                                                "
                                            ></i>
                                        </a>

                                        <ul
                                            class="dropdown-menu"
                                            v-if="option.opciones.length > 0"
                                        >
                                            <li
                                                class="nav-item"
                                                v-for="(
                                                    submenu, key
                                                ) in option.opciones"
                                                :key="key"
                                            >
                                                <router-link
                                                    v-if="submenu.tipo != 3"
                                                    :to="{
                                                        name: 'page',
                                                        params: {
                                                            id: submenu.url,
                                                        },
                                                    }"
                                                    class="nav-link"
                                                >
                                                    {{ submenu.nombre }}
                                                </router-link>
                                                <a
                                                    v-else
                                                    target="_blank"
                                                    :href="submenu.link"
                                                    class="nav-link"
                                                >
                                                    {{ submenu.nombre }}
                                                </a>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                        <div class="others-options d-flex align-items-center">
                            <!-- <div class="option-item">
                                <i
                                    class="search-btn flaticon-magnifying-glass"
                                ></i>
                                <i class="close-btn flaticon-close"></i>
                                <div class="search-overlay search-popup">
                                    <div class="search-box">
                                        <form class="search-form">
                                            <input
                                                class="search-input"
                                                name="search"
                                                placeholder="Search"
                                                type="text"
                                            />
                                            <button
                                                class="search-button"
                                                type="submit"
                                            >
                                                <i
                                                    class="flaticon-magnifying-glass"
                                                ></i>
                                            </button>
                                        </form>
                                    </div>
                                </div>
                            </div> -->
                            <div class="option-item" v-if="contacto.valor">
                                <div class="info">
                                    <i class="flaticon-telephone"></i>
                                    <span>Tienes dudas?</span>
                                    <p>
                                        <a
                                            :href="
                                                'tel:' +
                                                contacto.valor.telefonos
                                            "
                                            >{{ contacto.valor.telefonos }}</a
                                        >
                                    </p>
                                </div>
                            </div>
                            <div class="option-item">
                                <router-link
                                    v-if="authenticate == null"
                                    :to="{ name: 'login' }"
                                    class="default-btn"
                                >
                                    Iniciar sesión
                                    <span></span>
                                </router-link>
                                <ul class="navbar-nav" v-else>
                                    <li class="nav-item">
                                        <img
                                            :alt="authenticate.name"
                                            v-if="authenticate.exist"
                                            :src="authenticate.imagen"
                                            style="
                                                border-radius: 20px;
                                                width: 40px;
                                            "
                                        />
                                        <img
                                            v-else
                                            :alt="authenticate.name"
                                            :src="
                                                'data:image/png;base64,' +
                                                authenticate.avatar
                                            "
                                            style="
                                                border-radius: 20px;
                                                width: 40px;
                                            "
                                        />
                                        {{ authenticate.name }}
                                        <ul class="dropdown-menu">
                                            <li class="nav-item">
                                                <router-link
                                                    :to="{ name: 'profile' }"
                                                    >Mi perfil</router-link
                                                >
                                            </li>
                                            <li class="nav-item">
                                                <a href="/cms"
                                                    >Panel de control</a
                                                >
                                            </li>
                                            <li class="nav-item">
                                                <a href="#" @click="logout()"
                                                    >Cerrar sesión</a
                                                >
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </nav>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
    watch: {
        "webconfig.valor.escritorio": function (val, old) {
            this.get();
        },
    },
    mounted() {
        this.auth();
        this.get();
    },
    data: function () {
        return {
            menu: null,
        };
    },
    methods: {
        ...mapActions("security", ["auth"]),
        get() {
            if (this.webconfig.valor) {
                axios
                    .get("/api/menus/" + this.webconfig.valor.escritorio)
                    .then((response) => {
                        let decode = response.decode ?? response;
                        if (decode.data) {
                            this.menu = decode.data;
                            setTimeout(() => {

                            }, 1500);
                        }
                    })
                    .catch((error) => {});
            }
        },
        logout() {
            axios
                .post("/api/logout")
                .then((response) => {
                    let decode = response.decode ?? response;
                    localStorage.removeItem("csrf_tokenizer");
                    localStorage.removeItem("access_token");
                    window.location.reload();
                })
                .catch((error) => {
                    localStorage.removeItem("csrf_tokenizer");
                    localStorage.removeItem("access_token");
                });
        },
    },
    computed: {
        ...mapState("preferencias", ["preferencias", "contacto", "webconfig"]),
        ...mapState("security", ["authenticate"]),
    },
};
</script>
